import React from 'react'
import $ from 'jquery'
import easing from 'jquery.easing'
import BrandImage from '../../assets/img/Brand.png'
import { navbarConfig } from '../../constants'

const Navbar = () => {
    $(function() {
        const checkNavbarFixed = () => {
            const navbar = $('.navbar')
            if ( window.scrollY > $('header').offset().top ) {
                $('.navbar').css('position', 'fixed')
                navbar.addClass('navbar-fixed')
            } else {
                $('.navbar').css('position', 'absolute')
                navbar.removeClass('navbar-fixed')
            }
        }
        checkNavbarFixed()
        $('.nav-link').on('click', function(e) {
            const href = $(this).attr('href')
            let top = $(href).offset().top
            if ( top != 0 ) {
                top = top - 100
            }
            $('html').animate({
                scrollTop: top
            }, 800, 'easeInOutExpo')
            e.preventDefault()
        })
        const header = $('header')
        $('.hamburger').on('click', function() {
            header.addClass('navbar-show')
        })
        $('.hamburger-close').on('click', function() {
            header.removeClass('navbar-show')
        })
        window.onscroll = function() {
            checkNavbarFixed()
        }
    })
    return (
        <header>
            <div className="navbar w-full p-4 flex justify-between items-center bg-primary fixed z-50 shadow-sm selection:bg-white selection:text-primary">
                {/* <h1 className='text-xl font-bold text-light selection:bg-white selection:text-primary'>Rudin Engineer</h1> */}
                <div>
                    <a href="#home" className='nav-link'>
                        <img src={BrandImage} alt="Rudin Engineer" className='max-w-[200px] max-h-[30px]'/>
                    </a>
                </div>
                <ul className='hidden items-center gap-8 text-light px-4 font-semibold sm:flex'>
                    {
                        navbarConfig.map((value, index) => (
                            <li className='transition duration-500 ease-in-out hover:text-secondary'><a href={ value.url } className='nav-link selection:bg-white selection:text-primary'>{ value.name }</a></li>
                        ))
                    }
                    <a href="https://wa.me/6283851585361" className='px-4 py-2 bg-light text-primary rounded-full font-semibold text-xs border-2 border-transparent transition duration-500 ease-in-out hover:bg-transparent hover:border-light hover:text-light selection:bg-teal-400 selection:text-primary'>Contact Me</a>
                </ul>
                <div className="hamburger text-light cursor-pointer sm:hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                    </svg>
                </div>
            </div>
            <div className="navbar-hidden fixed top-0 right-0 w-full h-full bg-primary bg-opacity-95 transition duration-500 ease-in-out translate-x-[100%] z-50 sm:hidden">
                <div className="absolute right-0 text-light flex justify-end px-4 py-4">
                    <div className="hamburger-close cursor-pointer">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </div>
                </div>
                <ul className='w-full h-full flex flex-col justify-evenly items-center text-white'>
                    {
                        navbarConfig.map((value, index) => (
                            <li className='transition duration-500 ease-in-out hover:text-secondary'><a href={ value.url } className='nav-link selection:bg-white selection:text-primary'>{ value.name }</a></li>
                        ))
                    }
                </ul>
            </div>
        </header>
    )
}

export default Navbar